import { t } from "i18next";
import { TEXT_FIELD_TYPE, NUMERIC_RANGE_FIELD_TYPE } from "../../helpers/constants";

export const LEADS_AGGREGATION_TABLE_NAME = "leads_aggregation_table";

export const useLeadsAggregationTableFieldsConfig = () => {
    return [
        {
            name: "label_name",
            getValueCallback: (rowData) => rowData.label_name,
            label: t("leads.table.contactSource"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "lead_count",
            getValueCallback: (rowData) => rowData.lead_count,
            label: t("leads.table.leadCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "client_count",
            getValueCallback: (rowData) => rowData.client_count,
            label: t("leads.table.clientCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "last_client_count",
            getValueCallback: (rowData) => rowData.last_client_count,
            label: t("leads.table.lastClientCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "lead_fiasko_count",
            getValueCallback: (rowData) => rowData.lead_fiasko_count,
            label: t("leads.table.leadFiaskoCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "lead_mistake_count",
            getValueCallback: (rowData) => rowData.lead_mistake_count,
            label: t("leads.table.leadMistakeCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "offer_fiasko_count",
            getValueCallback: (rowData) => rowData.offer_fiasko_count,
            label: t("leads.table.offerFiaskoCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "contact_count",
            getValueCallback: (rowData) => rowData.contact_count,
            label: t("leads.table.contactCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "client_contact_count",
            getValueCallback: (rowData) => rowData.client_contact_count,
            label: t("leads.table.clientContactCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "client_booking_count",
            getValueCallback: (rowData) => rowData.client_booking_count,
            label: t("leads.table.clientBookingCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "client_aggrement_count",
            getValueCallback: (rowData) => rowData.client_aggrement_count,
            label: t("leads.table.clientAggrementCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        {
            name: "aggrement_count",
            getValueCallback: (rowData) => rowData.aggrement_count,
            label: t("leads.table.aggrementCount"),
            filterType: NUMERIC_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: false,
            headerSx: { whiteSpace: "break-spaces" }
        },
        
    ];
};
